import React, { useEffect, useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { PREVIEW_BACKEND_API_LOCALHOST } from "../../settings/shared/constants";

export default function CustomSwaggerUI({ specUrl }) {
  const [spec, setSpec] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reload, setReloadCount] = useState(false);

  useEffect(() => {
    async function loadSpec() {
      setLoading(true);
      setError(null);
      setSpec(null);
      try {
        const finalSpecUrl = localStorage.getItem('environmentType') === "K8S" ? specUrl : `${PREVIEW_BACKEND_API_LOCALHOST}`;
        const res = await fetch(finalSpecUrl);
        if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        const data = await res.json();
        setSpec(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    loadSpec();
  }, [specUrl, reload]);

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          padding: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontFamily: "Inter, sans-serif",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
          <h3 style={{ color: "#dc2626", marginBottom: "8px" }}>
            Failed to Load API Documentation
          </h3>
          <p style={{ color: "#64748b", fontSize: "14px", marginBottom: "12px" }}>
            {error}
          </p>
          <button
            onClick={() => setReloadCount((prev) => !prev)}
            style={{
              marginTop: "16px",
              padding: "8px 20px",
              border: "1px solid #dc2626",
              backgroundColor: "#dc2626",
              color: "white",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "400px",
          padding: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontFamily: "Inter, sans-serif",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "3px solid #e5e7eb",
              borderTop: "3px solid #4f46e5",
              borderRadius: "50%",
              margin: "0 auto 16px",
              animation: "spin 1s linear infinite",
            }}
          />
          <style>
            {`
              @keyframes spin {
                to { transform: rotate(360deg); }
              }
            `}
          </style>
          <p style={{ color: "#64748b", fontSize: "14px" }}>
            Loading API documentation...
          </p>
        </div>
      </div>
    );
  }

  return (
    <SwaggerUI
      spec={spec}
    />
  );
}